module.exports = __webpack_public_path__ + "static/media/icon-external-link-dark.7bbe720d.svg";